var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.toggleHelp}},[_c('i',{staticClass:"fas fa-question-circle"}),_vm._v(" Help")])}
var staticRenderFns = []

export { render, staticRenderFns }